import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { SiteManagerComponent } from 'src/app/site-manager/site-manager.component';
import { UserComponent } from 'src/app/user/user.component';
import { FeedermanagerComponent } from '../feedermanager/feedermanager.component';

@Component({
  selector: 'app-manager',
  templateUrl: './manager.component.html',
  styleUrls: ['./manager.component.scss']
})
export class ManagerComponent implements OnInit {

  constructor( private matDialog: MatDialog) { }

  ngOnInit() {
  }
  openManagerSettings() {
    let dialogRef;
    dialogRef = this.matDialog.open(FeedermanagerComponent, {
      height: '90%',
      width: '90%',
    });
  }
  openSiteManager() {
    let dialogRef;
    dialogRef = this.matDialog.open(SiteManagerComponent, {
      height: '90%',
      width: '90%',
    });
  }
  openUserMaintainance() {
    let dialogRef;
    dialogRef = this.matDialog.open(UserComponent, {
      height: '90%',
      width: '90%',
    });
  }
}
